@if (loading()) {
	<div class="flex grow items-center justify-center" data-cy="trade-history-loading">
		<ui-loading message="در حال دریافت سابقه معاملات ..." />
	</div>
} @else if (isEmpty()) {
	@if (error(); as message) {
		<ui-empty-state
			class="grow items-center"
			data-cy="trade-history-error"
			variant="error"
			description=""
			iconName="alert-box"
			primaryButtonLabel="تلاش مجدد"
			[title]="message"
			[showButton]="true"
			(primaryClicked)="onRetry()" />
	} @else {
		<ui-empty-state data-cy="trade-history-empty" variant="info" description="" title="سابقه معاملاتی وجود ندارد" />
	}
} @else {
	<div
		infiniteScroll
		class="flex flex-col gap-1.5"
		data-cy="trade-history-list"
		[infiniteScrollConfig]="{ rootMargin: '0px 0px 200px 0px' }"
		(lastItemVisibilityChanged)="onScrollEndVisibilityChanged($event)">
		@for (entry of days(); track entry.day.timeOfEvent) {
			<app-daily-history-card [history]="entry.day" [previousClosePrice]="entry.previousClosePrice" />
		}

		@if (loadingMore()) {
			<div class="flex items-center justify-center py-3" data-cy="trade-history-loading-more">
				<ui-loading />
			</div>
		} @else if (error(); as message) {
			<ui-empty-state
				class="py-3"
				data-cy="trade-history-load-more-retry"
				variant="error"
				description=""
				iconName="alert-box"
				primaryButtonLabel="تلاش مجدد"
				[title]="message"
				[showButton]="true"
				(primaryClicked)="onRetry()" />
		}
	</div>
}
